// extracted by mini-css-extract-plugin
module.exports = {"content":"ng","lookName":"og","shopTheLookContainer":"pg","productContainer":"qg","imageContainer":"rg","mainImage":"sg"};